import tourvisorAPI from '../../api/tourvisorAPI';

const TOURS_REQUEST_INTERVAL = 2000;

// Класс для получения туров
class TourFetcher {
  tourResults = [];

  constructor(requests) {
    this.requests = requests; // Список объектов Request
  }

  parseToursFromCache(request, requestCacheData, callback) {
    const { result } = requestCacheData;
    result.hotel.map((hotel) => {
      hotel.departure = request.requestData['departure'];
      this.tourResults.push(hotel);
    });
    callback([...this.tourResults, ...result.hotel]);
  }

  async parseToursResult(request, requestId, callback) {
    console.warn('ПОЛУЧИЛИ REQUEST ID ', requestId);
    const onpage = request.requestData['onpage'];
    let hotels = [];
    // Опрашивать URL для результатов каждые 2 секунды
    let progress = 0;
    while (progress < 100) {
      const resultResponse = await tourvisorAPI.result(requestId, onpage);

      progress = resultResponse.data.status.progress;

      if (progress < 100) {
        // Ждем 2 секунды перед следующим опросом
        console.log('// Progress ', progress, resultResponse);
        if (
          resultResponse.data.result &&
          resultResponse.data.result.hotel &&
          resultResponse.data.result.hotel.length
        ) {
          // первые результаты
          hotels = resultResponse.data.result.hotel.map((hotel) => {
            hotel.departure = request.requestData['departure'];
            return hotel;
          });

          callback([...this.tourResults, ...hotels]);
        }
        await new Promise((resolve) =>
          setTimeout(resolve, TOURS_REQUEST_INTERVAL)
        );
      } else {
        console.log('// Результат завершен, добавляем его в список');
        if (
          resultResponse.data.result &&
          resultResponse.data.result.hotel &&
          resultResponse.data.result.hotel.length
        ) {
          resultResponse.data.result.hotel.map((hotel) => {
            hotel.departure = request.requestData['departure'];
            this.tourResults.push(hotel);
          });
          callback([...this.tourResults, ...resultResponse.data.result.hotel]);
        }
        break;
      }
    }
  }

  checkToursResult(request, requestId, callback) {
    if (typeof requestId === 'object') {
      this.parseToursFromCache(request, requestId, callback);
    } else if (typeof requestId === 'number') {
      this.parseToursResult(request, requestId, callback);
    } else {
      alert('error parse tours');
    }
  }
  // Метод для получения результатов по запросам
  async fetchTourResults(callback) {
    console.warn('FETCH START');
    const tourResults = [];

    let counter = 0;
    for (const request of this.requests) {
      console.warn('ОТПРАВЛЯЕМ ЗАПРОС ', ++counter);
      request.send().then((r) => this.checkToursResult(request, r, callback));
    }
    return tourResults;
  }
}

export default TourFetcher;
